import React, { useMemo } from "react";
import { ItemField, UpdateItemRootOnBasket } from "../../../Redux/Reducers/redux-slice-basket";
import FormSection from "../../Forms/FormSection/form-section";
import { DbOrderBasketItemInfos } from "../../../Core/Api/Types/db-order-basket-item-infos";
import ConfigFormIcon from "../ConfigFormIcon";
import { UserHasAcl } from "../../../Utils/helpers";
import { useDispatch } from "react-redux";
import GlobalConst from "../../../Core/Utils/Constants/globals";
import FormInputDateTime from "../../Forms/FormInputDate/form-input-date-time";
import { AclTypes } from "../../../Core/Api/Types/acl-types";
import dayjs from "dayjs";
import moment from "moment";
import { useTranslation } from "react-i18next";

interface ConfigCommonFormDeliveryProps {
  item: DbOrderBasketItemInfos;
  formid: string;
}

const ConfigCommonSectionFormScheduling: React.FC<ConfigCommonFormDeliveryProps> = (props) => {
  const { t } = useTranslation();
  const { item, formid } = props;
  const dispatch = useDispatch();
  const userCanScheduleOrder = useMemo(() => UserHasAcl(AclTypes.aclOrderSchedule), []);

  const handleUpdateItemRoot = (field: ItemField, value: any) => {
    dispatch(UpdateItemRootOnBasket({ itemId: item.id, field: field, value: value }));
  };

  return (
    <>
      {item.selectedProduct?.scheduleEnabled && userCanScheduleOrder ? (
        <FormSection
          icon={<ConfigFormIcon icon="scheduling" />}
          title={t("common:scheduling")}
          status={!item.scheduleTime ? "todo" : "complete"}
          statusText={
            !item.scheduleTime
              ? t("form:statusText.configurationIsOptional")
              : moment(item.scheduleTime.toString()).format(GlobalConst.MOMENT_DATE_FORMAT_FULL)
          }
        >
          <FormInputDateTime
            label={t("field:label.itemScheduledTime")}
            format={GlobalConst.MOMENT_DATE_FORMAT_FULL}
            value={item.scheduleTime !== null ? dayjs(item.scheduleTime) : null}
            onChange={(value) => handleUpdateItemRoot(ItemField.ScheduleTime, value)}
            onReset={() => handleUpdateItemRoot(ItemField.ScheduleTime, null)}
            stackProps={{ mt: 1 }}
            validationProps={{
              formId: formid,
              formSectionId: "sectionScheduling",
              fieldId: "scheduleTime",
              initialState: true,
              required: false,
              onlyInFuture: true,
            }}
          />
        </FormSection>
      ) : (
        ""
      )}
    </>
  );
};

export default ConfigCommonSectionFormScheduling;
